'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
import { troubleshootActionTypes } from 'MeetingsLib/redux/actions/TroubleshootActions';
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.TOGGLE_TROUBLESHOOT_MODE, function (state, action) {
  return Object.assign({}, state, {
    active: action.active
  });
}), _defineProperty(_handleActions, troubleshootActionTypes.RECEIVE_TROUBLESHOOT_TIMES, function (state, action) {
  return Object.assign({}, state, {
    data: action.data
  });
}), _handleActions), {
  active: false,
  data: undefined
});